/* NFG Redesign v2 — shared behaviour */
(function () {
  'use strict';

  /* ---------- Toronto time helpers ---------- */
  // Converts "YYYY-MM-DD HH:MM" (Toronto local time) to a UTC timestamp, DST-aware.
  function torontoToUtc(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return NaN;
    var y = +m[1], mo = +m[2] - 1, d = +m[3], h = m[4] ? +m[4] : 23, mi = m[5] ? +m[5] : 59;
    var guess = Date.UTC(y, mo, d, h, mi);
    try {
      var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
      var parts = {};
      fmt.formatToParts(new Date(guess)).forEach(function (p) { parts[p.type] = p.value; });
      var asToronto = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
      return guess + (guess - asToronto);
    } catch (e) {
      return guess + 5 * 3600 * 1000; // fallback EST
    }
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Countdowns ---------- */
  function initCountdowns() {
    if (window.__nfgCountdown) return;
    var els = document.querySelectorAll('[data-nfg-countdown]');
    if (!els.length) return;
    var end = torontoToUtc(els[0].getAttribute('data-nfg-countdown'));
    window.__nfgCountdown = true;
    if (isNaN(end)) { els.forEach(function (el) { el.classList.add('is-ended'); }); return; }
    function tick() {
      var ms = Math.max(0, end - Date.now());
      var d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24, m = Math.floor(ms / 60000) % 60, s = Math.floor(ms / 1000) % 60;
      document.querySelectorAll('[data-nfg-countdown]').forEach(function (el) {
        if (ms <= 0) { el.classList.add('is-ended'); return; }
        el.querySelectorAll('[data-u]').forEach(function (n) {
          var u = n.getAttribute('data-u');
          n.textContent = u === 'd' ? (n.hasAttribute('data-raw') ? d : pad(d)) : u === 'h' ? pad(h) : u === 'm' ? pad(m) : pad(s);
        });
        el.querySelectorAll('[data-short]').forEach(function (n) {
          n.textContent = d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s);
        });
      });
      if (ms <= 0) { document.querySelectorAll('[data-nfg-sale-only]').forEach(function (n) { n.style.display = 'none'; }); return; }
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-nfg-tabs]').forEach(function (wrap) {
      if (wrap.__nfgTabs) return; wrap.__nfgTabs = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  /* ---------- Sticky bars (show after first screen) ---------- */
  function initSticky() {
    var bars = document.querySelectorAll('[data-nfg-sticky]');
    if (!bars.length) return;
    document.body.classList.add('nfg-has-sticky');
    function onScroll() {
      var show = window.scrollY > window.innerHeight * 0.6;
      bars.forEach(function (b) {
        var hideWhen = b.getAttribute('data-hide-when-visible');
        var target = hideWhen ? document.querySelector(hideWhen) : null;
        var targetVisible = false;
        if (target) { var r = target.getBoundingClientRect(); targetVisible = r.bottom > 0 && r.top < window.innerHeight; }
        b.classList.toggle('is-visible', show && !targetVisible);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Delivery fee calculator ----------
     Settings: Theme settings > NFG – Delivery calculator (rendered by snippets/nfg-delivery-config.liquid).
     Data:     assets/nfg-delivery-zones.json (scanned from checkout 2026-10-19)
       geo:    postal prefix (3-5 chars) -> [lat, lng] centre, for Ontario, Quebec and Alberta
       ab:     Alberta postal area -> fee cents as checkout charges it; abFree: fee -> free-over cents
       fx:     exact postal codes pinned to what checkout charged (used only with the default Toronto/Ottawa setup)
     Distances are straight lines, the same way Shopify Local Delivery measures them. */
  var ORIGINS = {
    toronto:  { location: [43.7501049, -79.5541097], city_hall: [43.6534, -79.3841] },   // Finch Store / 100 Queen St W
    ottawa:   { location: [45.382117, -75.5999609],  city_hall: [45.4209, -75.6901] },   // 2710 Stevenage Dr / 110 Laurier Ave W
    edmonton: { location: [53.5600106, -113.6433626], city_hall: [53.5444, -113.4904] } // 18552 111 Ave NW / 1 Sir Winston Churchill Sq
  };
  var DEFAULT_BANDS = {
    toronto:  '40:89.99:699.99, 80:149.99:1299.99, 120:199.99:1999.99, 160:299.99:2499.99',
    ottawa:   '40:99.99:699.99, 80:149.99:1299.99, 120:199.99:1999.99, 160:299.99:2499.99',
    edmonton: '40:89.99:699.99, 80:169.00:1699.99, 120:199.99:2499.99, 160:299.99:2999.99'
  };
  var zonesPromise = null;
  function loadZones(url) {
    if (!zonesPromise) zonesPromise = fetch(url).then(function (r) { if (!r.ok) throw new Error('zones'); return r.json(); }).catch(function (e) { zonesPromise = null; throw e; });
    return zonesPromise;
  }
  function deliveryConfig() {
    var c = {};
    try { c = JSON.parse((document.getElementById('nfg-delivery-config') || {}).textContent || '{}'); } catch (e) { c = {}; }
    c.hubs = c.hubs || {};
    return c;
  }
  function kmBetween(a, b) {
    var t = Math.PI / 180, dLa = (b[0] - a[0]) * t, dLo = (b[1] - a[1]) * t;
    var s = Math.pow(Math.sin(dLa / 2), 2) + Math.cos(a[0] * t) * Math.cos(b[0] * t) * Math.pow(Math.sin(dLo / 2), 2);
    return 12742 * Math.asin(Math.sqrt(s));
  }
  // "40:89.99:699.99, 80:..." -> [[40, 8999, 69999], ...] sorted by distance; null if nothing valid
  function parseBands(str) {
    var out = [];
    String(str || '').split(/[,;\n]+/).forEach(function (part) {
      var b = part.replace(/[$\s]/g, '').split(':');
      var km = parseFloat(b[0]), fee = parseFloat(b[1]), free = b[2] === undefined || b[2] === '' ? null : parseFloat(b[2]);
      if (km > 0 && fee >= 0) out.push([km, Math.round(fee * 100), free === null || isNaN(free) ? null : Math.round(free * 100)]);
    });
    out.sort(function (a, b) { return a[0] - b[0]; });
    return out.length ? out : null;
  }
  function normBands(str) { return String(str || '').replace(/\s+/g, ''); }
  function parsePoint(str) {
    var m = String(str || '').match(/(-?\d+(?:\.\d+)?)\s*[, ]\s*(-?\d+(?:\.\d+)?)/);
    if (!m) return null;
    var la = parseFloat(m[1]), lo = parseFloat(m[2]);
    return (Math.abs(la) <= 90 && Math.abs(lo) <= 180) ? [la, lo] : null;
  }
  function hubSetup(cfg, key) {
    var h = (cfg.hubs || {})[key] || {};
    var origin = ORIGINS[key][h.origin] || (h.origin === 'custom' && parsePoint(h.custom)) || ORIGINS[key].location;
    var bandsStr = h.bands || DEFAULT_BANDS[key];
    return {
      key: key,
      enabled: h.enabled !== false,
      origin: origin,
      isDefault: (h.origin || 'location') === 'location' && normBands(bandsStr) === normBands(DEFAULT_BANDS[key]),
      bands: parseBands(bandsStr) || parseBands(DEFAULT_BANDS[key])
    };
  }
  function bandAt(hub, point) {
    var d = kmBetween(point, hub.origin);
    for (var i = 0; i < hub.bands.length; i++) if (d <= hub.bands[i][0]) return { fee: hub.bands[i][1], free: hub.bands[i][2], km: d, hub: hub.key };
    return null;
  }
  function geoFor(z, pc) {
    var c = null;
    for (var n = 5; n >= 3 && !c; n--) c = (z.geo || {})[pc.slice(0, n)] || null;
    return c;
  }
  function freeFor(hub, fee) {
    for (var i = 0; i < hub.bands.length; i++) if (hub.bands[i][1] === fee) return hub.bands[i][2];
    return null;
  }
  // Returns { fee, free } | { call: true } (Ontario, outside every band: checkout offers "call for a quote") | null (not served)
  function lookupFee(z, pc, cfg) {
    cfg = cfg || {};
    var ontario = /^[KLMNP]/.test(pc);
    if (pc[0] === 'T') {
      var ed = hubSetup(cfg, 'edmonton');
      if (!ed.enabled) return null;
      if ((cfg.edmontonMethod || 'checkout') !== 'distance') {
        var a = (z.ab || {})[pc.slice(0, 3)];
        return a ? { fee: a, free: (z.abFree || {})[String(a)] } : null;
      }
      var tp = geoFor(z, pc);
      var tb = tp ? bandAt(ed, tp) : null;
      return tb ? { fee: tb.fee, free: tb.free } : null;
    }
    var hubs = [hubSetup(cfg, 'toronto'), hubSetup(cfg, 'ottawa')];
    var live = hubs.filter(function (h) { return h.enabled; });
    // Pinned band-edge codes only apply while both hubs use the default setup they were scanned with
    if (z.fx && live.length === 2 && hubs[0].isDefault && hubs[1].isDefault && Object.prototype.hasOwnProperty.call(z.fx, pc)) {
      var f = z.fx[pc];
      if (f < 0) return ontario ? { call: true } : null;
      return { fee: f, free: freeFor(hubs[0], f) || freeFor(hubs[1], f) };
    }
    var c = geoFor(z, pc);
    if (!c) return ontario ? { call: true } : null;
    var best = null;
    live.forEach(function (h) { var b = bandAt(h, c); if (b && (!best || b.fee < best.fee)) best = b; });
    return best ? { fee: best.fee, free: best.free } : (ontario ? { call: true } : null);
  }
  function orderValue(form) {
    // Product page: this item x quantity, plus whatever is already in the cart (checkout prices the whole order)
    var pdp = form.closest('[data-nfg-pdp]');
    var item = 0;
    if (pdp) {
      var btn = pdp.querySelector('[data-nfg-add]');
      var qi = pdp.querySelector('[data-nfg-qty-input]');
      item = (Number(btn && btn.getAttribute('data-base')) || 0) * Math.max(1, parseInt(qi && qi.value, 10) || 1);
    } else if (form.getAttribute('data-order-value')) {
      item = Number(form.getAttribute('data-order-value')) || 0;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return { item: item, total: item + (c.items_subtotal_price || 0), cart: c.items_subtotal_price || 0 }; })
      .catch(function () { return { item: item, total: item, cart: 0 }; });
  }
  function showPostal(pc) {
    document.querySelectorAll('[data-nfg-postal-show]').forEach(function (n) { n.textContent = pc; });
  }
  function initPostal() {
    document.querySelectorAll('[data-nfg-postal]').forEach(function (form) {
      if (form.__nfgPostal) return; form.__nfgPostal = true;
      var tel = form.getAttribute('data-tel') || '647-748-1424';
      var input = form.querySelector('input');
      var out = form.querySelector('[data-result]');
      var cfg = deliveryConfig();
      var url = cfg.zonesUrl || form.getAttribute('data-zones');
      try { var s = localStorage.getItem('nfg_postal'); if (s && !input.value) input.value = s; } catch (e) {}
      function check(e) {
        if (e) e.preventDefault();
        var pc = (input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(pc)) { out.textContent = 'Please enter a full postal code, e.g. M9M 2E9.'; return; }
        var nice = pc.slice(0, 3) + ' ' + pc.slice(3);
        out.textContent = 'Checking…';
        Promise.all([loadZones(url), orderValue(form)]).then(function (res) {
          var hit = lookupFee(res[0], pc, cfg), v = res[1];
          if (!hit) {
            out.innerHTML = '';
            out.appendChild(document.createTextNode('We don’t deliver to ' + nice + ' yet. Call ' + tel + ' and we’ll see what we can do.'));
            return;
          }
          try { localStorage.setItem('nfg_postal', nice); } catch (err) {}
          showPostal(nice);
          if (hit.call) { out.textContent = 'Delivery to ' + nice + ' is quoted by phone — call ' + tel + '. You can still place your order online.'; return; }
          var free = hit.free, fee = hit.fee, msg;
          var isPdp = !!form.closest('[data-nfg-pdp]');
          if (fee === 0 || (free && v.total >= free)) {
            msg = 'Free delivery to ' + nice + (isPdp ? (v.cart ? ' for this item plus your cart.' : ' for this item.') : '.');
          } else if (isPdp || v.total) {
            msg = 'Delivery to ' + nice + ': ' + money(fee) + (free ? ' — free on orders over ' + money(free) + ' (add ' + money(free - v.total) + ' more).' : '.');
          } else {
            msg = 'We deliver to ' + nice + '. Delivery is ' + money(fee) + (free ? ', or free on orders over ' + money(free) + '.' : '.');
          }
          out.textContent = msg + ' Final fee confirmed at checkout.';
          if (isPdp) {
            var curb = form.closest('[data-nfg-pdp]').querySelector('[data-nfg-dyn="curb"]');
            if (curb) curb.textContent = (fee === 0 || (free && v.total >= free)) ? 'Free' : money(fee);
          }
        }).catch(function () { out.textContent = 'We couldn’t check right now. Your exact delivery fee is shown at checkout, or call ' + tel + '.'; });
      }
      if (form.tagName === 'FORM') {
        form.addEventListener('submit', check);
      } else {
        // Inside the product form: a nested <form> isn't allowed, so use the button and Enter key instead
        var btn = form.querySelector('[data-check]');
        if (btn) btn.addEventListener('click', check);
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') check(e); });
      }
      if (input.value && form.hasAttribute('data-autocheck')) check();
      // Product page: re-check after a variant change (new price) so the fee stays right
      if (form.closest('[data-nfg-pdp]')) document.addEventListener('nfg:pdp-updated', function () { if (/^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i.test((input.value || '').trim()) && out.textContent) check(); });
    });
    var saved = null; try { saved = localStorage.getItem('nfg_postal'); } catch (e) {}
    if (saved) showPostal(saved);
  }

  /* ---------- First-visit popup ---------- */
  function initPopup() {
    var pop = document.getElementById('nfg-popup');
    if (!pop) return;
    var KEY = 'nfg_popup_seen';
    var dialog = pop.querySelector('.nfg-pop__dialog');
    function open() {
      if (pop.classList.contains('is-open')) return;
      pop.classList.add('is-open');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      var first = pop.querySelector('input, button'); if (first) first.focus();
    }
    function close() { pop.classList.remove('is-open'); }
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-nfg-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (pop.hasAttribute('data-posted')) { open(); return; }
    var seen = null; try { seen = localStorage.getItem(KEY); } catch (e) {}
    if (seen && Date.now() - Number(seen) < 14 * 86400000) return; // show once every 14 days
    if (/\/(cart|checkout|account)/.test(location.pathname)) return;
    var delay = (Number(pop.getAttribute('data-delay')) || 12) * 1000;
    var timer = setTimeout(open, delay);
    window.addEventListener('scroll', function onS() {
      var doc = document.documentElement;
      if (window.scrollY > (doc.scrollHeight - window.innerHeight) * 0.5) { clearTimeout(timer); open(); window.removeEventListener('scroll', onS); }
    }, { passive: true });
  }

  /* ---------- Complete the look ---------- */
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0]);
  }
  function initCompleteLook() {
    document.querySelectorAll('[data-nfg-ctl]').forEach(function (box) {
      var productId = box.getAttribute('data-product-id');
      var base = Number(box.getAttribute('data-base-price')) || 0;
      var list = box.querySelector('[data-items]');
      var totalEl = box.querySelector('[data-total]');
      var countEl = box.querySelector('[data-count]');
      var btn = box.querySelector('[data-add]');
      function recalc() {
        var t = base, c = 1;
        list.querySelectorAll('input[type=checkbox]:checked:not([disabled])').forEach(function (i) { t += Number(i.getAttribute('data-price')) || 0; c++; });
        totalEl.textContent = money(t); countEl.textContent = c;
      }
      var series = (box.getAttribute('data-product-title') || '').split(' ')[0].toLowerCase();
      var ownType = (box.getAttribute('data-product-type') || '').toLowerCase();
      var fallback = [];
      try { fallback = JSON.parse(box.parentNode.querySelector('[data-nfg-ctl-fallback]').textContent); } catch (e) {}
      // "Complete the look" must suggest a different kind of piece (a table or rug for a sofa), never a second sofa.
      var hiddenTypes = (box.getAttribute('data-hidden-types') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      function usable(p) {
        return p && p.available && String(p.id) !== productId &&
          hiddenTypes.indexOf(String(p.type || '').toLowerCase().trim()) === -1 &&
          p.title.split(' ')[0].toLowerCase() !== series &&
          !(ownType && String(p.type || '').toLowerCase() === ownType);
      }
      function render(products) {
        products = (products || []).filter(usable).slice(0, 2);
        if (!products.length) products = fallback.filter(usable).slice(0, 2);
        if (!products.length) { box.closest('.nfg-ctl-section').style.display = 'none'; return; }
        products.forEach(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160') : '';
          var label = document.createElement('label');
          label.className = 'nfg-ctl__item';
          label.innerHTML = '<input type="checkbox" checked data-variant="' + v.id + '" data-price="' + v.price + '">' +
            '<span class="nfg-ph nfg-ctl__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
            '<span><span class="nfg-ctl__name"></span><span class="nfg-ctl__price">' + money(v.price) + '</span></span>';
          label.querySelector('.nfg-ctl__name').textContent = p.title;
          list.appendChild(label);
        });
        list.addEventListener('change', recalc);
        recalc();
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=4&intent=complementary')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          // Complementary picks (set in Search & Discovery) first; otherwise the fallback collections.
          // "Related" recommendations are not used here: they return look-alikes (another sectional), not companions.
          render((j && j.products) || []);
        })
        .catch(function () { box.closest('.nfg-ctl-section').style.display = 'none'; });

      btn.addEventListener('click', function () {
        var mainId = box.getAttribute('data-variant-id');
        var formIdInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (formIdInput && formIdInput.value) mainId = formIdInput.value;
        var items = [{ id: Number(mainId), quantity: 1 }];
        list.querySelectorAll('input[type=checkbox]:checked:not([disabled])').forEach(function (i) { items.push({ id: Number(i.getAttribute('data-variant')), quantity: 1 }); });
        btn.disabled = true; var txt = btn.textContent; btn.textContent = 'Adding…';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { window.location.href = root + 'cart'; })
          .catch(function () { btn.disabled = false; btn.textContent = txt; alert('Sorry, we could not add these items. Please try again.'); });
      });
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-nfg-satc]');
    if (!bar) return;
    var btn = bar.querySelector('[data-satc-add]');
    if (btn) btn.addEventListener('click', function () {
      var main = document.querySelector('[data-nfg-add]') || document.querySelector('.product-form__add-button[type="submit"]');
      if (main && !main.disabled) { main.click(); }
      else { var top = document.querySelector('[data-nfg-form]') || document.querySelector('.product-form'); if (top) top.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
    // Keep price in sync after variant change
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant; if (!v) return;
      var p = bar.querySelector('[data-satc-price]'); if (p) p.textContent = money(v.price);
      var c = bar.querySelector('[data-satc-compare]'); if (c) c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
    });
  }


  /* ---------- Service add-ons (Room of Choice / White Glove products) ---------- */
  function initAddons() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nfg-addon]');
      if (!b) return;
      e.preventDefault();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var txt = b.textContent; b.disabled = true; b.textContent = 'Adding…';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-nfg-addon')), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          b.textContent = 'Added ✓';
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: null, openMiniCart: false } }));
        })
        .catch(function () { b.disabled = false; b.textContent = txt; });
    });
  }


  /* ---------- Product page v2 ---------- */
  function initPdp() {
    var root = document.querySelector('[data-nfg-pdp]');
    if (!root) return;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-nfg-variants]').textContent); } catch (e) {}
    var form = root.querySelector('[data-nfg-form]');
    var idInput = root.querySelector('[data-nfg-variant-input]');
    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');
    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Gallery thumbnails
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-nfg-thumb]');
      if (!t) return;
      var idx = t.getAttribute('data-nfg-thumb');
      root.querySelectorAll('.nfg-gal__slide').forEach(function (sl) { sl.hidden = sl.getAttribute('data-media-index') !== idx; });
      root.querySelectorAll('[data-nfg-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    });

    function qtyInput() { return root.querySelector('[data-nfg-qty-input]'); }
    function selectedService() { var r = root.querySelector('input[name="nfg_delivery"]:checked'); return r && r.value ? { id: Number(r.value), price: Number(r.getAttribute('data-price')) || 0 } : null; }
    function updateTotal() {
      var btn = root.querySelector('[data-nfg-add]'); if (!btn) return;
      var q = Math.max(1, parseInt(qtyInput().value, 10) || 1);
      var t = (Number(btn.getAttribute('data-base')) || 0) * q;
      var svc = selectedService(); if (svc) t += svc.price;
      var out = btn.querySelector('[data-nfg-total]'); if (out) out.textContent = money(t);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nfg-qty]'); if (!b) return;
      var i = qtyInput(); i.value = Math.min(99, Math.max(1, (parseInt(i.value, 10) || 1) + Number(b.getAttribute('data-nfg-qty'))));
      updateTotal();
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-nfg-qty-input], input[name="nfg_delivery"]')) updateTotal(); });

    // Options -> variant
    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-nfg-option]'), function (fs) {
        var on = fs.querySelector('[aria-pressed="true"]'); return on ? on.getAttribute('data-value') : null;
      });
    }
    function findVariant(opts) {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
    }
    function markAvailability() {
      var fs = root.querySelectorAll('[data-nfg-option]');
      var opts = currentOptions();
      fs.forEach(function (f, i) {
        f.querySelectorAll('[data-value]').forEach(function (b) {
          var test = opts.slice(); test[i] = b.getAttribute('data-value');
          var v = findVariant(test);
          b.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function swapRegions(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-nfg-dyn]').forEach(function (n) {
        var cur = root.querySelector('[data-nfg-dyn="' + n.getAttribute('data-nfg-dyn') + '"]');
        if (!cur) return;
        // Keep the same Add to cart element when it stays available: apps (CPS) bind to it on page load
        var oldBtn = cur.querySelector('[data-nfg-add]'), newBtn = n.querySelector('[data-nfg-add]');
        if (oldBtn && newBtn) {
          oldBtn.setAttribute('data-base', newBtn.getAttribute('data-base'));
          var ot = oldBtn.querySelector('[data-nfg-total]'), nt = newBtn.querySelector('[data-nfg-total]');
          if (ot && nt) ot.textContent = nt.textContent;
          return;
        }
        cur.innerHTML = n.innerHTML;
      });
      var satc = document.querySelector('[data-satc-price]'), nsatc = doc.querySelector('[data-satc-price]');
      if (satc && nsatc) satc.parentNode.innerHTML = nsatc.parentNode.innerHTML;
      updateTotal(); markAvailability();
      document.dispatchEvent(new CustomEvent('nfg:pdp-updated'));
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nfg-option] [data-value]');
      if (!b) return;
      var fs = b.closest('[data-nfg-option]');
      fs.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var lab = fs.querySelector('.nfg-opt__label span'); if (lab) lab.textContent = b.getAttribute('data-value');
      var v = findVariant(currentOptions());
      if (!v) return;
      idInput.value = v.id; idInput.setAttribute('value', v.id);
      try { idInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) {}
      try { history.replaceState(null, '', productUrl + '?variant=' + v.id); } catch (err) {}
      document.querySelectorAll('[data-nfg-variant-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-nfg-variant-panel') !== String(v.id); });
      document.querySelectorAll('[data-nfg-sku]').forEach(function (n) { n.textContent = v.sku || ''; });
      fetch(productUrl + '?variant=' + v.id + '&section_id=' + sectionId).then(function (r) { return r.text(); }).then(swapRegions).catch(function () {});
    });
    markAvailability();

    // CPS protection widget: the app injects it next to the price; move it under the services, styled as a theme card.
    var cpsSlot = root.querySelector('[data-nfg-cps-slot]');
    function placeCps() {
      if (!cpsSlot) return;
      var w = root.querySelector('.cps_cart, .cps5312-wrapper');
      if (w && w.parentNode !== cpsSlot && !cpsSlot.contains(w)) cpsSlot.appendChild(w);
    }
    placeCps();
    if (cpsSlot && window.MutationObserver) {
      var cpsObs = new MutationObserver(placeCps);
      cpsObs.observe(root, { childList: true, subtree: true }); // CPS can re-inject after a variant change
    }

    // Warranty apps (CPS) take over the Add to cart click and only send the product form.
    // When that happens, add the chosen delivery service ourselves; undo it if their popup is closed without adding.
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nfg-add]'); if (!b) return;
      setTimeout(function () {
        if (!e.defaultPrevented) return; // our own submit handler adds the service
        var svc = selectedService(); if (!svc || b.__nfgSvc) return;
        b.__nfgSvc = svc.id;
        fetch(shopRoot + 'cart/add.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: svc.id, quantity: 1 }] }) })
          .catch(function () {});
        var closeX = document.getElementById('cps-jump-1-close');
        if (closeX && !closeX.__nfg) {
          closeX.__nfg = true;
          closeX.addEventListener('click', function () {
            var sid = b.__nfgSvc; b.__nfgSvc = null; if (!sid) return;
            fetch(shopRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(sid), quantity: 0 }) }).catch(function () {});
          });
        }
      }, 0);
    }, true);

    // Add to cart (main item + selected delivery service), then open the theme mini cart
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = root.querySelector('[data-nfg-add]'); if (!btn || btn.disabled) return;
      var err = root.querySelector('[data-nfg-error]'); err.hidden = true;
      var q = Math.max(1, parseInt(qtyInput().value, 10) || 1);
      var items = [{ id: Number(idInput.value), quantity: q }];
      var svc = selectedService(); if (svc) items.push({ id: svc.id, quantity: 1 });
      var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () {
          btn.disabled = false; btn.innerHTML = label;
          document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: null, quantity: q, productAdded: true, button: btn } }));
          if (!document.querySelector('#mini-cart')) window.location.href = shopRoot + 'cart';
        })
        .catch(function (ex) { btn.disabled = false; btn.innerHTML = label; err.textContent = ex.message; err.hidden = false; });
    });
  }


  /* ---------- Collection page v2 ---------- */
  function initCollection() {
    var root = document.querySelector('[data-nfg-col]');
    if (!root) return;
    var form = root.querySelector('[data-nfg-filter-form]');
    var isMobile = function () { return window.matchMedia('(max-width: 999px)').matches; };
    function go(params) {
      var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.href = url;
    }
    function formParams() {
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      return params;
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (isMobile()) return; // on phones, apply with the "Show results" button
        if (e.target.type === 'number') return;
        go(formParams());
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(formParams()); });
    }
    root.querySelectorAll('[data-nfg-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sel.value); params.delete('page');
        go(params);
      });
    });
    var panel = root.querySelector('[data-nfg-filters]');
    root.querySelectorAll('[data-nfg-filters-open]').forEach(function (b) { b.addEventListener('click', function () { panel.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }); });
    root.querySelectorAll('[data-nfg-filters-close]').forEach(function (b) { b.addEventListener('click', function () { panel.classList.remove('is-open'); document.documentElement.style.overflow = ''; }); });

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-nfg-loadmore]');
      if (!a) return;
      e.preventDefault();
      var sid = root.getAttribute('data-section-id');
      var url = a.getAttribute('href');
      a.textContent = 'Loading…';
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-nfg-grid]');
          doc.querySelectorAll('[data-nfg-grid] > .nfg-ccard').forEach(function (c) { grid.appendChild(c); });
          var more = root.querySelector('[data-nfg-more]'), nmore = doc.querySelector('[data-nfg-more]');
          if (more && nmore) more.innerHTML = nmore.innerHTML;
        })
        .catch(function () { window.location.href = url; });
    });
  }

  function initFinCalc() {
    var root = document.querySelector('[data-nfg-fincalc]');
    if (!root || root.__nfg) return; root.__nfg = true;
    var amtIn = root.querySelector('[data-fc-amt]'), range = root.querySelector('[data-fc-range]');
    var plans = root.querySelectorAll('[data-fc-plan]'), chips = root.querySelectorAll('[data-fc-preset]');
    var state = { n: 12, r: 0 };
    function money(v) { return '$' + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function set(sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }
    function render() {
      var amt = Math.max(0, parseFloat(amtIn.value) || 0), pay, interest;
      if (state.n === 0) {
        set('[data-fc-label]', 'Minimum payment during the promotional period');
        set('[data-fc-big]', '$0/mo');
        set('[data-fc-line]', 'Pay ' + money(amt) + ' in full by the end of your plan and all accrued interest is waived.');
        set('[data-fc-p]', money(amt)); set('[data-fc-i]', '$0 if paid on time'); set('[data-fc-t]', money(amt));
      } else {
        if (state.r > 0) { var i = state.r / 12; pay = amt * i / (1 - Math.pow(1 + i, -state.n)); interest = pay * state.n - amt; }
        else { pay = amt / state.n; interest = 0; }
        set('[data-fc-label]', 'Your estimated monthly payment');
        set('[data-fc-big]', money(pay) + '/mo');
        set('[data-fc-line]', 'for ' + state.n + ' months · ' + (state.r ? (state.r * 100).toFixed(2) + '% AIR' : '0% interest'));
        set('[data-fc-p]', money(amt)); set('[data-fc-i]', money(interest)); set('[data-fc-t]', money(amt + interest));
      }
      chips.forEach(function (c) { c.classList.toggle('is-on', parseFloat(c.getAttribute('data-fc-preset')) === amt); });
    }
    function setAmt(v, from) {
      if (from !== 'input') amtIn.value = v;
      if (from !== 'range') range.value = Math.min(Math.max(v, +range.min), +range.max);
      render();
    }
    amtIn.addEventListener('input', function () { setAmt(parseFloat(amtIn.value) || 0, 'input'); });
    range.addEventListener('input', function () { setAmt(parseFloat(range.value), 'range'); });
    chips.forEach(function (c) { c.addEventListener('click', function () { setAmt(parseFloat(c.getAttribute('data-fc-preset'))); }); });
    plans.forEach(function (b) {
      b.addEventListener('click', function () {
        plans.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        state.n = parseInt(b.getAttribute('data-fc-plan'), 10); state.r = parseFloat(b.getAttribute('data-fc-rate')) || 0;
        render();
      });
    });
    var q = new URLSearchParams(window.location.search).get('amount');
    var start = q && !isNaN(parseFloat(q)) ? Math.round(parseFloat(q) * 100) / 100 : parseFloat(amtIn.value) || 2499;
    setAmt(start);
  }

  /* ---------- Terms checkbox before checkout (cart page + drawer) ---------- */
  function initTerms() {
    if (window.__nfgTerms) return; window.__nfgTerms = true;
    function stamp() {
      try { return 'Yes - ' + new Date().toLocaleString('en-CA', { timeZone: 'America/Toronto', dateStyle: 'medium', timeStyle: 'short' }) + ' (Toronto)'; }
      catch (e) { return 'Yes - ' + new Date().toISOString(); }
    }
    function saveAttr(val) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { 'Terms accepted': val } }) }).catch(function () {});
    }
    function boxFor(el) {
      var scope = el.closest('form') || document;
      return scope.querySelector('[data-nfg-terms]');
    }
    function showErr(box, on) {
      var wrap = box.closest('[data-nfg-terms-wrap]'); if (!wrap) return;
      var err = wrap.querySelector('[data-nfg-terms-err]');
      wrap.classList.toggle('is-error', on);
      if (err) err.hidden = !on;
      if (on) { wrap.classList.remove('is-shake'); void wrap.offsetWidth; wrap.classList.add('is-shake'); }
    }
    document.addEventListener('change', function (e) {
      var box = e.target.closest && e.target.closest('[data-nfg-terms]'); if (!box) return;
      // keep every copy (drawer + cart page) in sync
      document.querySelectorAll('[data-nfg-terms]').forEach(function (b) { b.checked = box.checked; if (box.checked) showErr(b, false); });
      saveAttr(box.checked ? stamp() : '');
    });
    function guard(e, trigger) {
      var box = boxFor(trigger);
      if (!box || box.checked) return;
      e.preventDefault(); e.stopImmediatePropagation();
      showErr(box, true);
      try { box.focus({ preventScroll: true }); box.closest('[data-nfg-terms-wrap]').scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {}
    }
    // capture phase so the check runs before the theme / other apps send the customer to checkout
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
      if (t) guard(e, t);
    }, true);
    document.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (sub && sub.name === 'checkout') guard(e, sub);
    }, true);
  }

  /* ---------- Product gallery: click to view full screen (desktop) ---------- */
  function initLightbox() {
    if (window.__nfgLb) return; window.__nfgLb = true;
    var narrow = window.matchMedia('(max-width: 999px)');
    var lb, imgEl, stageEl, countEl, thumbsEl, items = [], idx = 0, lastFocus = null, pushed = false, tx = null, ty = 0, moved = false;
    function build() {
      lb = document.createElement('div');
      lb.className = 'nfg nfg-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product images, full screen'); lb.hidden = true;
      lb.innerHTML = '<button type="button" class="nfg-lb__close" data-lb-close aria-label="Close full screen">&times;</button>' +
        '<span class="nfg-lb__count" aria-live="polite"></span>' +
        '<button type="button" class="nfg-lb__nav nfg-lb__nav--prev" data-lb-step="-1" aria-label="Previous image">&#8249;</button>' +
        '<div class="nfg-lb__stage" data-lb-stage><img class="nfg-lb__img" alt=""></div>' +
        '<button type="button" class="nfg-lb__nav nfg-lb__nav--next" data-lb-step="1" aria-label="Next image">&#8250;</button>' +
        '<div class="nfg-lb__thumbs"></div>';
      document.body.appendChild(lb);
      imgEl = lb.querySelector('.nfg-lb__img'); stageEl = lb.querySelector('[data-lb-stage]'); countEl = lb.querySelector('.nfg-lb__count'); thumbsEl = lb.querySelector('.nfg-lb__thumbs');
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) return close();
        var s = e.target.closest('[data-lb-step]'); if (s) return show(idx + Number(s.getAttribute('data-lb-step')));
        var th = e.target.closest('[data-lb-i]'); if (th) return show(Number(th.getAttribute('data-lb-i')));
        if (moved) { moved = false; return; }
        if (e.target === imgEl) return toggleZoom(e);
        if (e.target.closest('[data-lb-stage]') || e.target === lb) close();
      });
      imgEl.addEventListener('mousemove', function (e) { if (lb.classList.contains('is-zoomed') && !narrow.matches) origin(e); });
      // phones: swipe left/right to change image (when not zoomed in)
      stageEl.addEventListener('touchstart', function (e) {
        moved = false; if (lb.classList.contains('is-zoomed') || e.touches.length > 1) { tx = null; return; }
        tx = e.touches[0].clientX; ty = e.touches[0].clientY;
      }, { passive: true });
      stageEl.addEventListener('touchend', function (e) {
        if (tx === null) return; var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) { moved = true; show(idx + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
    }
    function origin(e) {
      var r = imgEl.getBoundingClientRect();
      imgEl.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    }
    function toggleZoom(e) {
      var on = !lb.classList.contains('is-zoomed');
      if (!narrow.matches) { lb.classList.toggle('is-zoomed', on); if (on) origin(e); return; }
      // phones: show the image larger and let the customer drag it around
      var r = imgEl.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      lb.classList.toggle('is-zoomed', on);
      if (on) { stageEl.scrollLeft = fx * stageEl.scrollWidth - stageEl.clientWidth / 2; stageEl.scrollTop = fy * stageEl.scrollHeight - stageEl.clientHeight / 2; }
      else { stageEl.scrollLeft = 0; stageEl.scrollTop = 0; }
    }
    function show(i) {
      if (!items.length) return;
      idx = (i + items.length) % items.length;
      lb.classList.remove('is-zoomed'); if (stageEl) { stageEl.scrollLeft = 0; stageEl.scrollTop = 0; }
      imgEl.src = items[idx].src; imgEl.alt = items[idx].alt;
      countEl.textContent = (idx + 1) + ' / ' + items.length;
      thumbsEl.querySelectorAll('[data-lb-i]').forEach(function (b, n) { b.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
      var one = items.length < 2; lb.querySelectorAll('[data-lb-step]').forEach(function (b) { b.hidden = one; }); thumbsEl.hidden = one;
    }
    function open(slide) {
      var gal = slide.closest('.nfg-gal'); if (!gal) return;
      var slides = [].slice.call(gal.querySelectorAll('.nfg-gal__slide[data-nfg-zoom]'));
      items = slides.map(function (s) { var t = s.querySelector('img'); return { src: s.getAttribute('data-nfg-zoom'), alt: s.getAttribute('data-nfg-zoom-alt') || '', thumb: t ? (t.currentSrc || t.src) : '', mi: s.getAttribute('data-media-index') }; });
      if (!lb) build();
      thumbsEl.innerHTML = items.map(function (it, n) { return '<button type="button" class="nfg-lb__thumb" data-lb-i="' + n + '" aria-label="Image ' + (n + 1) + '"><img src="' + it.thumb + '" alt="" loading="lazy"></button>'; }).join('');
      lastFocus = document.activeElement;
      lb.hidden = false; document.documentElement.classList.add('nfg-lb-open');
      // the phone's Back button closes the viewer instead of leaving the page
      try { history.pushState({ nfgLb: 1 }, ''); pushed = true; } catch (err) { pushed = false; }
      show(Math.max(0, slides.indexOf(slide)));
      lb.querySelector('[data-lb-close]').focus();
    }
    function close(fromHistory) {
      if (!lb || lb.hidden) return;
      if (pushed) { pushed = false; if (fromHistory !== true) { try { history.back(); } catch (err) {} } }
      lb.hidden = true; document.documentElement.classList.remove('nfg-lb-open');
      // leave the page gallery on the image the customer was looking at
      var it = items[idx];
      if (it) { var th = document.querySelector('.nfg-gal [data-nfg-thumb="' + it.mi + '"]'); if (th) th.click(); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    window.addEventListener('popstate', function () { if (lb && !lb.hidden) close(true); });
    document.addEventListener('click', function (e) {
      var slide = e.target.closest && e.target.closest('.nfg-gal__slide[data-nfg-zoom]');
      if (!slide || e.target.closest('button, a, model-viewer, video')) return;
      var gm = slide.closest('.nfg-gal__main'); if (gm && gm.__nfgSwiped && Date.now() - gm.__nfgSwiped < 400) return;
      e.preventDefault(); open(slide);
    });
    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'Tab') { // keep focus inside the viewer
        var f = [].slice.call(lb.querySelectorAll('button:not([hidden])')); if (!f.length) return;
        var a = f.indexOf(document.activeElement);
        if (e.shiftKey && a <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && a === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  /* ---------- "You may also like" (Shopify related recommendations, NFG cards) ---------- */
  function initRecs() {
    document.querySelectorAll('[data-nfg-recs][data-url]').forEach(function (sec) {
      if (sec.getAttribute('data-loaded')) return; sec.setAttribute('data-loaded', '1');
      fetch(sec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-nfg-recs]');
        if (fresh && fresh.querySelector('.nfg-pcard')) { sec.innerHTML = fresh.innerHTML; sec.hidden = false; }
      }).catch(function () {});
    });
  }

  /* ---------- Recently viewed (remembered in this browser only) ---------- */
  var RECENT_KEY = 'nfg_recent';
  function readRecent() {
    try {
      var a = JSON.parse(localStorage.getItem(RECENT_KEY) || 'null');
      if (!a) a = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // carry over the old theme's list
      return Array.isArray(a) ? a.map(Number).filter(Boolean) : [];
    } catch (e) { return []; }
  }
  function initRecent() {
    var pdp = document.querySelector('[data-nfg-pdp]');
    var current = 0;
    if (pdp) {
      var sec0 = document.querySelector('[data-nfg-recent]');
      current = Number(sec0 && sec0.getAttribute('data-current')) || Number((window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || 0);
    }
    var list = readRecent();
    document.querySelectorAll('[data-nfg-recent]').forEach(function (sec) {
      var count = Number(sec.getAttribute('data-count')) || 4;
      var ids = list.filter(function (id) { return id !== current; }).slice(0, count + 2);
      if (!ids.length) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      fetch(root + 'search?type=product&options[unavailable_products]=last&q=' + encodeURIComponent(q) + '&section_id=nfg-recently-viewed')
        .then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var cards = [].slice.call(tmp.querySelectorAll('[data-nfg-recent-items] .nfg-pcard')).slice(0, count);
          if (!cards.length) return;
          var grid = sec.querySelector('[data-nfg-recent-grid]');
          cards.forEach(function (c) { grid.appendChild(c); });
          sec.hidden = false;
        }).catch(function () {});
    });
    if (current) {
      try { localStorage.setItem(RECENT_KEY, JSON.stringify([current].concat(list.filter(function (id) { return id !== current; })).slice(0, 12))); } catch (e) {}
    }
  }

  /* ---------- Recent sales popup (real orders only) ---------- */
  function initSalesPopup() {
    var box = document.querySelector('[data-nfg-sales]');
    if (!box || box.getAttribute('data-init')) return; box.setAttribute('data-init', '1');
    var sales = [];
    try { sales = JSON.parse(box.querySelector('[data-nfg-sales-data]').textContent) || []; } catch (e) { sales = []; }
    var maxDays = Number(box.getAttribute('data-max-days')) || 30;
    var DAY = 86400000;
    function parseDate(s) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s || '').trim()); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
    var today = new Date(); today.setHours(0, 0, 0, 0);
    sales = sales.map(function (s) { var d = parseDate(s.date); s.days = d ? Math.round((today - d) / DAY) : -1; return s; })
      .filter(function (s) { return s.days >= 0 && s.days <= maxDays && s.title && s.city; })
      .sort(function (a, b) { return a.days - b.days; });
    if (!sales.length) return;
    var preview = box.getAttribute('data-preview') === '1';
    var KEY = 'nfg_sp_state';
    var st = { n: 0, i: 0, off: false };
    try { st = Object.assign(st, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
    if (st.off && !preview) return;
    var max = Number(box.getAttribute('data-max')) || 4;
    var delay = (Number(box.getAttribute('data-delay')) || 12) * 1000;
    var showFor = (Number(box.getAttribute('data-show')) || 6) * 1000;
    var gap = (Number(box.getAttribute('data-gap')) || 30) * 1000;
    var label = box.getAttribute('data-label') || 'Someone in [city], [province] purchased';
    var link = box.querySelector('[data-sp-link]'), img = box.querySelector('[data-sp-img]');
    var who = box.querySelector('[data-sp-who]'), title = box.querySelector('[data-sp-title]'), when = box.querySelector('[data-sp-when]');
    var timer;
    function ago(d) { return d === 0 ? 'Today' : d === 1 ? 'Yesterday' : d + ' days ago'; }
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
    function hide() { box.classList.remove('is-in'); timer = setTimeout(function () { box.hidden = true; next(); }, 400); }
    function show() {
      if (document.hidden) { timer = setTimeout(show, 3000); return; }
      var s = sales[st.i % sales.length];
      st.i++; st.n++; save();
      link.href = s.url || '#';
      img.innerHTML = s.image ? '<img src="' + String(s.image).replace(/"/g, '') + '" alt="" width="64" height="64" loading="lazy">' : '';
      who.textContent = label.replace('[city]', s.city).replace('[province]', s.province || '').replace(/,\s*$/, '').replace(/ ,/g, ',');
      title.textContent = s.title;
      when.textContent = ago(s.days);
      box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-in'); });
      timer = setTimeout(hide, showFor);
    }
    function next() { if (!preview && st.n >= max) return; timer = setTimeout(show, st.n ? gap : delay); }
    box.querySelector('[data-sp-close]').addEventListener('click', function () { clearTimeout(timer); st.off = true; save(); box.classList.remove('is-in'); box.hidden = true; });
    box.addEventListener('mouseenter', function () { clearTimeout(timer); });
    box.addEventListener('mouseleave', function () { if (box.classList.contains('is-in')) timer = setTimeout(hide, 2000); });
    next();
  }

  /* ---------- Cart: "away from free delivery" bar ---------- */
  function initFreebar(scope) {
    (scope || document).querySelectorAll('[data-nfg-freebar]').forEach(function (bar) {
      if (bar.__nfgFb) return; bar.__nfgFb = true;
      var sub = Number(bar.getAttribute('data-subtotal')) || 0;
      var km = bar.getAttribute('data-km') || '40';
      var msg = bar.querySelector('[data-fb-msg]'), fill = bar.querySelector('[data-fb-bar]');
      var where = bar.querySelector('[data-fb-where]'), toggle = bar.querySelector('[data-fb-toggle]');
      var form = bar.querySelector('[data-fb-form]'), input = bar.querySelector('[data-fb-input]'), go = bar.querySelector('[data-fb-go]');
      var cfg = deliveryConfig();
      var url = cfg.zonesUrl || bar.getAttribute('data-zones');
      function set(html, pct, done) {
        msg.innerHTML = html;
        fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
        fill.parentNode.setAttribute('aria-valuenow', String(Math.round(Math.max(0, Math.min(100, pct)))));
        bar.classList.toggle('is-done', !!done);
      }
      function apply(nice) {
        var pc = nice.replace(/\s/g, '');
        loadZones(url).then(function (z) {
          var hit = lookupFee(z, pc, cfg);
          where.textContent = 'Delivering to ' + nice + '.';
          toggle.textContent = 'Change';
          if (!hit) { set('We don’t deliver to <b>' + nice + '</b> yet. Call us and we’ll see what we can do.', 0, false); return; }
          if (hit.call) { set('Delivery to <b>' + nice + '</b> is quoted by phone. You can still check out online.', 0, false); return; }
          if (hit.fee === 0) { set('<b>Free delivery</b> to ' + nice + '.', 100, true); return; }
          if (!hit.free) { set('Delivery to <b>' + nice + '</b>: ' + money(hit.fee) + '.', 0, false); return; }
          var left = hit.free - sub;
          if (left <= 0) set('Your order qualifies for <b>free delivery</b> to ' + nice + '.', 100, true);
          else set('Add <b>' + money(left) + '</b> more for <b>free delivery</b> to ' + nice + ' (otherwise ' + money(hit.fee) + ').', sub / hit.free * 100, false);
        }).catch(function () {});
      }
      toggle.addEventListener('click', function () { form.hidden = !form.hidden; if (!form.hidden) input.focus(); });
      function submit() {
        var pc = (input.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(pc)) { input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
        input.removeAttribute('aria-invalid');
        var nice = pc.slice(0, 3) + ' ' + pc.slice(3);
        try { localStorage.setItem('nfg_postal', nice); } catch (e) {}
        form.hidden = true; apply(nice); showPostal(nice);
      }
      go.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
      var saved = null; try { saved = localStorage.getItem('nfg_postal'); } catch (e) {}
      if (saved) { input.value = saved; apply(saved); }
    });
  }
  // The cart drawer is re-drawn whenever the cart changes: set up any new bar that appears
  if (window.MutationObserver) {
    var fbQueued = false;
    new MutationObserver(function () {
      if (fbQueued) return; fbQueued = true;
      setTimeout(function () { fbQueued = false; if (document.querySelector('[data-nfg-freebar]')) initFreebar(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Google Analytics: call and WhatsApp clicks as leads ---------- */
  // GA4 itself is loaded by the Google & YouTube app; this only adds a "generate_lead" event when a shopper taps Call or WhatsApp.
  function initLeadTracking() {
    if (window.__nfgLeads) return; window.__nfgLeads = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
      var href = a.getAttribute('href') || '', method = null;
      if (/^tel:/i.test(href)) method = 'phone';
      else if (/wa\.me|whatsapp\.com/i.test(href)) method = 'whatsapp';
      else if (/^mailto:/i.test(href)) method = 'email';
      if (!method) return;
      var where = (a.closest('[data-nfg-pdp]') && 'product page') || (a.closest('.nfg-sticky, .nfg-satc') && 'sticky bar') || (a.closest('.mini-cart, .template-cart') && 'cart') || (a.closest('header, .header') && 'header') || (a.closest('footer, .footer') && 'footer') || 'page';
      window.dataLayer = window.dataLayer || [];
      var gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      try { gtag('event', 'generate_lead', { method: method, lead_source: method, link_location: where, page_type: (window.theme && window.theme.pageType) || '' }); } catch (err) {}
    }, true);
  }

  /* ---------- Shopify Inbox chat button on phones: small round icon that sits above the sticky add-to-cart bar ---------- */
  function initChatFit() {
    if (window.__nfgChat) return; window.__nfgChat = true;
    var css = '@media (max-width: 749px) {' +
      '.activator-nudge { bottom: var(--nfg-chat-bottom, 16px) !important; right: 12px !important; top: auto !important; left: auto !important; transition: bottom .2s ease, opacity .15s ease; opacity: var(--nfg-chat-op, 1); pointer-events: var(--nfg-chat-pe, auto); }' +
      '.activator { width: 48px !important; min-width: 48px !important; height: 48px !important; padding: 0 !important; border-radius: 50% !important; justify-content: center !important; box-shadow: 0 4px 14px rgba(0,0,0,.22) !important; }' +
      '.activator__label { display: none !important; }' +
      '.activator__icon { margin: 0 !important; }' +
      '}';
    var bar = document.querySelector('[data-nfg-satc]');
    function lift(host) {
      var up = bar && bar.classList.contains('is-visible') && bar.offsetHeight > 0;
      host.style.setProperty('--nfg-chat-bottom', up ? (bar.offsetHeight + 12) + 'px' : '16px');
    }
    var styled = window.WeakSet ? new WeakSet() : null;
    // The Inbox widget re-renders itself (sometimes into a nested shadow root), so find whichever root holds the button and style it
    function styleRoots(root) {
      if (!root) return;
      if (root.querySelector('.activator') && styled && !styled.has(root)) {
        styled.add(root);
        try { var sh = new CSSStyleSheet(); sh.replaceSync(css); root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sh]); }
        catch (err) { var st = document.createElement('style'); st.textContent = css; root.appendChild(st); }
      }
      var b = root.querySelector('.activator'); if (b && !b.getAttribute('aria-label')) b.setAttribute('aria-label', 'Chat with us');
      root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) styleRoots(el.shadowRoot); });
    }
    function fit(host) {
      if (!host.shadowRoot || !styled) return false;
      if (host.__nfgFit) { styleRoots(host.shadowRoot); return true; }
      host.__nfgFit = true;
      styleRoots(host.shadowRoot);
      lift(host);
      if (window.MutationObserver) new MutationObserver(function () { clearTimeout(host.__nfgT); host.__nfgT = setTimeout(function () { styleRoots(host.shadowRoot); }, 150); }).observe(host.shadowRoot, { childList: true, subtree: true });
      if (bar && window.MutationObserver) new MutationObserver(function () { lift(host); }).observe(bar, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
      // fade the chat button out while an Add to cart or Checkout button passes underneath it
      if (window.IntersectionObserver) {
        var io = null, under = new Map();
        var watch = function () {
          if (io) io.disconnect(); under.clear();
          var targets = document.querySelectorAll('[data-nfg-pdp] [data-nfg-add], .cart-recap__checkout, .mini-cart [name="checkout"]');
          if (!targets.length) return;
          io = new IntersectionObserver(function (en) {
            en.forEach(function (x) { under.set(x.target, x.isIntersecting && x.target.offsetParent !== null); });
            var hide = window.innerWidth < 750 && Array.from(under.values()).some(Boolean);
            host.style.setProperty('--nfg-chat-op', hide ? '0' : '1');
            host.style.setProperty('--nfg-chat-pe', hide ? 'none' : 'auto');
          }, { rootMargin: '-' + Math.max(0, window.innerHeight - 90) + 'px 0px 0px 0px' });
          targets.forEach(function (t) { io.observe(t); });
        };
        watch(); var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(watch, 250); });
        document.addEventListener('cart:refresh', function () { setTimeout(watch, 300); });
        document.addEventListener('nfg:cart-updated', function () { setTimeout(watch, 300); });
      }
      return true;
    }
    var tries = 0;
    (function wait() {
      var host = document.querySelector('shopify-chat');
      if (host) fit(host);
      if (++tries < 60) setTimeout(wait, 1000); // keep checking for a minute while the widget finishes loading
    })();
  }

  /* ---------- Product gallery: swipe between images on phones ---------- */
  function initGallerySwipe() {
    var main = document.querySelector('[data-nfg-pdp] .nfg-gal__main'); if (!main || main.__nfgSwipe) return; main.__nfgSwipe = true;
    var x = null, y = 0;
    main.addEventListener('touchstart', function (e) { if (e.touches.length > 1) { x = null; return; } x = e.touches[0].clientX; y = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x === null) return; var t = e.changedTouches[0], dx = t.clientX - x, dy = t.clientY - y; x = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      var thumbs = [].slice.call(document.querySelectorAll('[data-nfg-pdp] [data-nfg-thumb]')); if (thumbs.length < 2) return;
      var cur = thumbs.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; }); if (cur < 0) cur = 0;
      var next = thumbs[(cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
      main.__nfgSwiped = Date.now(); next.click(); if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }, { passive: true });
  }

  function init() {
    initCountdowns(); initTabs(); initSticky(); initPostal(); initPopup(); initCompleteLook(); initStickyAtc(); initAddons(); initPdp(); initCollection(); initFinCalc(); initTerms(); initLightbox(); initRecs(); initRecent(); initSalesPopup(); initFreebar(); initLeadTracking(); initChatFit(); initGallerySwipe();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); initCountdowns(); initPostal(); initRecs(); initSalesPopup(); });
})();
